import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import CustomBtn from "../../widgets/CustomBtn";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Dropdown from "react-bootstrap/Dropdown";
import JSZip from "jszip";
import { saveAs } from "file-saver";

// Importing image assets
import editGreenImg from "../../../assets/images/edit.png";
import deleteGreenImg from "../../../assets/images/delete.png";
import copyImg from "../../../assets/images/whiteCopy.svg";
import editImg from "../../../assets/images/whiteEdit.svg";
import printImg from "../../../assets/images/whitePrint.svg";
import deleteImg from "../../../assets/images/whiteDelete.svg";
import fixtureImg from "../../../assets/images/whiteFixture.svg";
import incidentImg from "../../../assets/images/incident.png";
import pointImg from "../../../assets/images/points.png";
import iconAddWhiteImg from "../../../assets/images/iconAddWhiteImg.svg";
import incidentGreen from "../../../assets/images/incident-green.png";
import incidentOrange from "../../../assets/images/incident-orange.png";
import incidentPink from "../../../assets/images/incident-pink.png";
import incidentRed from "../../../assets/images/incident-red.png";
import incidentYellow from "../../../assets/images/incident-yellow.png";

import {
  courseList,
  printCourse,
  publishCourse,
  downloadCourse,
  addCourse,
  updateCourse,
  deleteCourse,
  deleteQuest,
  updateGpsStatus,
  updateDigitalStatus,
  updatePromptSearchStatus,
  updateAutoPromptStatus,
  copyQuest,
  cloneCourseGroup,
  testCourse,
  getFixture,
  getIncidentTypes,
  getCourseFixtureIncident,
  getAllFixture,
  deleteCourseFixture,
  setClearCourseData,
} from "../../_slice/courseSlice";

import {
  addAssembly,
  addAssemblyPointId,
  assemblyList,
  deleteAssembly,
  removeAssembly,
  updateAssembly,
} from "../../_slice/assemblyPointSlice";

import CustomModal from "../../widgets/CustomModal";
import FixtureModal from "../../widgets/FixtureModal";
import QuestModal from "../../widgets/QuestModal";

import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import AppContext from "../../context/AppContext";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScroll from "../../services/InfiniteScroll";
import tinycolor from "tinycolor2"; // Ensure you have tinycolor2 installed
import Canvas from "../Canvas";
import { toast } from "react-toastify";

function Courses() {
  const houseCanvasRef = useRef(null);
  const busCanvasRef = useRef(null);

  const [key, setKey] = useState("home");
  const [assemblyListing, setAssemblyListing] = useState([]);
  const [assemblyModalShow, setAssemblyModalShow] = useState({
    show: false,
    title: "",
    courseId: "",
    locationId: "",
  });
  const [selectedAssemblyId, setSelectedAssemblyId] = useState("");

  const [deleteAssemblyModal, setDeleteAssemblyModal] = useState({
    show: false,
    courseId: "",
    assemblyId: "",
    assemblyName: "",
  });
  const [modalShow, setModalShow] = useState({ show: false, id: "" });
  const [printModalShow, setPrintModalShow] = useState({
    show: false,
    html: "",
    cclink: "",
    ccqrcodeurl: "",
    testlink: "",
    testqrcodeurl: "",
    id: "",
    name: "",
    testKey: null,
    incidentTypeId: "",
  });
  const [testQRShow, setTestQRShow] = useState({
    show: false,
    uuid: "",
    qrcodeurl: "",
  });
  const [iframeContent, setIframeContent] = useState("");
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    id: "",
    name: "",
    type: "",
  });
  const [downloadModal, setDownloadModal] = useState({
    show: false,
    courseId: "",
    incidentTypeId: "",
    questName: "",
    gps: false,
    published: "",
  });
  const [fixtureModalShow, setFixtureModalShow] = useState({
    show: false,
    zoneId: "",
    mode: "",
  });

  const [questModalShow, setQuestModalShow] = useState({
    show: false,
    courseId: "",
    mode: "",
  });

  // Copy Quest Modal State
  const [copyQuestModalShow, setCopyQuestModalShow] = useState({
    show: false,
    courseId: "",
    incidentTypeId: "",
    incidentTypeName: "",
  });

  // Clone Course Group (Quest Area) Modal State
  const [cloneCourseGroupModalShow, setCloneCourseGroupModalShow] = useState({
    show: false,
    courseGroupId: "",
    courseGroupName: "",
    defaultStartingMarker: "",
  });

  const [highlighted, setHighlighted] = useState([false, false, false]);
  const [showDetails, setShowDetails] = useState({});
  const [showParents, setShowParents] = useState({});
  const [checkedState, setCheckedState] = useState({});

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  // Initialize state to store colors for each course
  const [colors, setColors] = useState([]);

  // const [settingStatus, setSettingStatus] = useState(false);

  // Other hook initializations
  const { setLoader } = useContext(AppContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // console.log('location.state', location.state);

  const locationId = location?.state?.orglocation?.locationId || "";
  // const locationType = location?.state?.orglocation?.locationType || "";

  // Get From Local Storage
  const locationType = sessionStorage.getItem("locationType") || "";

  // Read is_deleted_by_admin flag from navigation state (fallback to sessionStorage on refresh).
  // When this is true, the parent location is locked — disable Create / Edit / Delete actions.
  const locationIsDeletedByAdmin =
    location?.state?.orglocation?.isDeletedByAdmin !== undefined
      ? location.state.orglocation.isDeletedByAdmin
      : sessionStorage.getItem("locationIsDeletedByAdmin") === "false"
      ? false
      : sessionStorage.getItem("locationIsDeletedByAdmin") === "true"
      ? true
      : null;
  const isLocationLocked = locationIsDeletedByAdmin === true;
  const lockedStyle = isLocationLocked
    ? { opacity: 0.5, cursor: "not-allowed", pointerEvents: "none" }
    : {};
  // console.log("locationType", locationType);

  const [selectedCourse, setSelectedCourse] = useState(null);

  // const assemblyId = location?.state?.assembly?.assemblyId || '';

  const onboardingData = useSelector((state) => state?.onboarding);

  const [confirmModalShow, setConfirmModalShow] = useState({ show: false });

  const [confirmPrint, setConfirmPrint] = useState(null);

  // Apply the blur effect when the confirmation modal is shown
  useEffect(() => {
    if (confirmModalShow.show) {
      document.body.classList.add("modal-blur");
    } else {
      document.body.classList.remove("modal-blur");
    }
  }, [confirmModalShow.show]);

  const handlePrintClick = (id, name, testKey, incidentTypeId) => {
    setConfirmPrint({ id, name, testKey, incidentTypeId });
    setConfirmModalShow({ show: true });
  };

  const handleConfirmPrint = () => {
    if (confirmPrint) {
      printCourseApi(confirmPrint.id, confirmPrint.name, confirmPrint.testKey, confirmPrint.incidentTypeId);
      setPrintModalShow({
        show: true,
        html: "",
        cclink: "",
        ccqrcodeurl: "",
        testlink: "",
        testqrcodeurl: "",
        id: confirmPrint.id,
        name: confirmPrint.name,
        testKey: confirmPrint.testKey,
        incidentTypeId: confirmPrint.incidentTypeId,
      });
    }
    setConfirmModalShow({ show: false });
  };

  // React Hook Form setup
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    clearErrors,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      starting_marker: "",
      name: "",
      hint: "",
      notes: "",
      color: "",
      location_id: locationId || "",
    },
  });

  // React Hook Form setup for Assembly form
  const {
    register: registerAssembly,
    handleSubmit: handleSubmitAssembly,
    watch: watchAssembly,
    formState: { errors: errorsAssembly },
    setValue: setValueAssembly,
    clearErrors: clearErrorsAssembly,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      name: "", // Default empty value for 'name'
    },
  });

  useEffect(() => {
    if (!assemblyModalShow.show) return;

    fetchAssembly(0);
    setValueAssembly("course_id", assemblyModalShow.courseId); // Dynamically set course_id when modal opens
    setValueAssembly("location_id", assemblyModalShow.locationId); // Dynamically set location_id when modal opens

    if (assemblyModalShow.title === "Add") {
      setValueAssembly("newAssemblyName", "");
      setValueAssembly("existingAssemblyName", "");
    }
  }, [assemblyModalShow, setValueAssembly]);

  // Redux selector
  const {
    courseData,
    status: courseStatus,
    fixtureData,
    courseIncidentTypesData,
    courseFixtureData,
    courseFixtureIncidentData,
  } = useSelector((state) => state.course);
  console.log('courseData', courseData);
  console.log('courseFixtureData', courseFixtureData);
  console.log('courseIncidentTypesData', courseIncidentTypesData);

  useEffect(() => {
    if (courseStatus === "idle" || locationId) {
      dispatch(courseList({ setLoader, locationId }));
      fetchMoreCourses(0);
    }
  }, [locationId, navigate, dispatch, setLoader]);

  // Function to fetch more location
  const fetchMoreCourses = (resetPage) => {
    const pageCount = resetPage > 0 ? resetPage : page;
    dispatch(setClearCourseData());

    dispatch(courseList({ locationId, pageCount, navigate, setLoader }))
      .then((response) => {
        // console.log('Api response', response);
        if (response?.payload?.data?.courses?.data?.length > 0) {
          setPage(response?.payload?.data?.courses?.current_page + 1);
          setHasMore(
            response?.payload?.data?.courses?.current_page <
            response?.payload?.data?.courses?.last_page
          );
        } else {
          setHasMore(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching more quests:", error);
      });
  };

  // Function to handle checkbox state changes
  const handleCheckboxChange = (event, id, name, startingMarker) => {

    const checked = event.target.checked;
    setCheckedState({ [id]: checked });
    setShowDetails({ [id]: checked });

    const {
      campus = { campId: "", campName: "" },
      orglocation = { locationId: "", locationName: "" },
      assembly = { assemblyId: "", assemblyName: "" },
      orgId = "",
    } = location?.state || {};

    const newState = {
      campus,
      orglocation,
      assembly,
      course: {
        courseId: checked ? id : "",
        courseName: checked ? name : "",
        starting_marker: checked ? startingMarker : "",
      },
      orgId,
    };

    if (checked) {
      dispatch(getIncidentTypes({ courseId: id, navigate, setLoader }));
    }

    navigate(".", { replace: true, state: newState });
  };

  // Function to fetch more location
  const fetchAssembly = (resetPage) => {
    // const pageCount = resetPage > 0 ? resetPage : page;
    const pageCount = 1;
    dispatch(assemblyList({ locationId, pageCount, navigate, setLoader }))
      .then((response) => {
        // console.log('assemblyList response', response);
        if (response?.payload?.data?.assemblyPoints?.data?.length > 0) {
          setAssemblyListing(response?.payload?.data?.assemblyPoints?.data);
        }
        // console.log('assemblyListing', assemblyListing);
      })
      .catch((error) => {
        console.error("Error fetching more assemblyPoints:", error);
      });
  };

  // Function to create a new assembly
  const createAssembly = async (data) => {
    // console.log("data", data);
    const course_id = data.course_id;

    const assemblyName =
      key === "home" ? data.newAssemblyName : data.existingAssemblyName;

    const formData = {
      ...data,
      name: assemblyName, // Assign the correct 'name' value
      location_id: assemblyModalShow.locationId, // Ensure location_id is passed
    };
    delete formData.newAssemblyName;
    delete formData.existingAssemblyName;
    delete formData.course_id;

    try {
      const response = await dispatch(
        addAssembly({ formData, navigate, setLoader })
      );

      const { location_id, id: assembly_point_id } =
        response?.payload?.assemblyPoint;

      const assemblyPointFormData = {
        location_id: location_id || assemblyModalShow.locationId,
        assembly_point_id,
      };

      await dispatch(
        addAssemblyPointId({
          formData: assemblyPointFormData,
          id: course_id,
          navigate,
          setLoader,
        })
      );

      setAssemblyModalShow({
        show: false,
        title: "",
        courseId: "",
        locationId: "",
      });
      await dispatch(setClearCourseData());
      const pageCount = 1;
      dispatch(courseList({ navigate, pageCount, setLoader, locationId }));
    } catch (error) {
      console.error("Error creating assembly:", error);
    }
  };

  // Function to edit an existing assembly
  const editAssembly = async (data) => {
    try {
      const course_id = data.course_id;
      const assemblyName =
        key === "home" ? data.newAssemblyName : data.existingAssemblyName;

      const formData = {
        ...data,
        name: assemblyName, // Assign the correct 'name' value
        location_id: assemblyModalShow.locationId, // Ensure location_id is passed
      };

      delete formData.newAssemblyName;
      delete formData.existingAssemblyName;
      delete formData.course_id;

      await dispatch(
        updateAssembly({
          id: assemblyModalShow.assemblyId,
          formData,
          navigate,
          setLoader,
          locationId,
        })
      );

      if (formData.name) {
        setAssemblyModalShow({
          show: false,
          title: "",
          courseId: "",
          locationId: "",
        });
        await dispatch(setClearCourseData());
        const pageCount = 1;
        dispatch(courseList({ navigate, pageCount, setLoader, locationId }));
      }
    } catch (error) {
      console.error("Error updating assembly:", error);
    }
  };

  // Function to create a new assembly
  const existAssembly = async (data) => {
    const course_id = data.courseId;
    const { location_id = assemblyModalShow.locationId, assemblyId } = data;

    // if (!assemblyId || !location_id) {
    //     console.warn("Invalid data: assemblyId or location_id is missing.");
    //     return;
    // }

    try {
      const assemblyPointFormData = {
        location_id,
        assembly_point_id: assemblyId,
      };

      await dispatch(
        addAssemblyPointId({
          formData: assemblyPointFormData,
          id: course_id,
          navigate,
          setLoader,
        })
      );

      setAssemblyModalShow({
        show: false,
        title: "",
        courseId: "",
        locationId: "",
      });
      await dispatch(setClearCourseData());

      const pageCount = 1;
      dispatch(courseList({ navigate, pageCount, setLoader, locationId }));
    } catch (error) {
      console.error("Error in existAssembly:", error);
    }
  };

  // Function to remove a assembly
  const removeAssemblyPoint = (courseId, assemblyId) => {
    dispatch(
      removeAssembly({ courseId, assemblyId, locationId, navigate, setLoader })
    ).then(() => {
      setDeleteAssemblyModal({ show: false });
      setAssemblyModalShow({
        show: false,
        title: "",
        courseId: "",
        locationId: "",
      });
      dispatch(setClearCourseData());
      const pageCount = 1;
      dispatch(courseList({ navigate, pageCount, setLoader, locationId }));
    });
  };

  const questModalApi = (courseId) => {
    // console.log('zoneId', zoneId, "ZoneAssembly", ZoneAssembly);
    getQuestListing(courseId, "addAndEdit");
  };

  // Function to toggle fixture modal visibility
  const openQuestModal = (courseId, mode) => {
    // console.log('zoneId DDDDDDD', zoneId);
    setQuestModalShow({
      show: true,
      courseId: courseId,
      mode: mode,
    });
    if (courseIncidentTypesData?.length === 0) getIncidentTypes();
  };

  const closeQuestModal = () => {
    setQuestModalShow({
      show: false,
      courseId: "",
      mode: "",
    });
  };

  // course Fixture Api Call On Click
  const courseFixtureApi = (zoneId, ZoneAssembly) => {
    // console.log('zoneId', zoneId, "ZoneAssembly", ZoneAssembly);
    getCourseFixtures(zoneId, "addAndEdit", ZoneAssembly);
  };

  // Function to toggle fixture modal visibility
  const openFixtureModal = (zoneId, mode, ZoneAssembly) => {
    // console.log('zoneId DDDDDDD', zoneId);
    setFixtureModalShow({
      show: true,
      zoneId: zoneId,
      mode: mode,
      ZoneAssembly: ZoneAssembly,
    });
    if (fixtureData?.length === 0) getFixtures();
  };

  const closeFixtureModal = () => {
    setFixtureModalShow({
      show: false,
      zoneId: "",
      mode: "",
      ZoneAssembly: "",
    });
  };

  // Handle GPS Checkbox - now per-quest (per incident type)
  const handleGpsCheckboxClick = (event, courseId, incidentTypeId) => {
    const isChecked = event.target.checked;

    // Dispatch the thunk with required parameters
    dispatch(
      updateGpsStatus({
        courseId,
        incidentTypeId,
        gps: isChecked,
        setLoader
      })
    ).then(() => {
      dispatch(courseList({ navigate, setLoader, locationId }));
      dispatch(getIncidentTypes({ courseId: courseId, navigate, setLoader }));
    });
  };

  // Handle Digital Only Checkbox
  const handleDigitalCheckboxClick = (event, courseId, incidentTypeId, fixtureId) => {
    const isChecked = event.target.checked;

    dispatch(
      updateDigitalStatus({
        digital_only: isChecked,
        courseId,
        incidentTypeId,
        fixtureId,
        setLoader
      })
    ).then(() => {
      dispatch(courseList({ navigate, setLoader, locationId }));
      dispatch(getIncidentTypes({ courseId: courseId, navigate, setLoader }));
    });
  };

  // Handle Prompt-Search Checkbox - per-quest (per incident type)
  const handlePromptSearchCheckboxClick = (event, courseId, incidentTypeId) => {
    const isChecked = event.target.checked;

    dispatch(
      updatePromptSearchStatus({
        courseId,
        incidentTypeId,
        promptSearch: isChecked,
        setLoader
      })
    ).then(() => {
      dispatch(courseList({ navigate, setLoader, locationId }));
      dispatch(getIncidentTypes({ courseId: courseId, navigate, setLoader }));
    });
  };

  // Handle Auto-Prompt Checkbox - per-quest (per incident type)
  const handleAutoPromptCheckboxClick = (event, courseId, incidentTypeId) => {
    const isChecked = event.target.checked;

    dispatch(
      updateAutoPromptStatus({
        courseId,
        incidentTypeId,
        autoPrompt: isChecked,
        setLoader
      })
    ).then(() => {
      dispatch(courseList({ navigate, setLoader, locationId }));
      dispatch(getIncidentTypes({ courseId: courseId, navigate, setLoader }));
    });
  };

  // Update Status
  // const updateStatus = (checkedValue, courseId) => {
  //   console.log('courseId', courseId);
  //   console.log('checkedValue', checkedValue);

  //   axiosInstance.post(`/updateSettingStatus`, { user_id: userId, push_status: checkedValue })
  //     .then((response) => {
  //       console.log('Response', response);
  //       toast.success(response.data.message || 'Status updated successfully');
  //     })
  //     .catch((error) => {
  //       console.error('Error updating status', error);
  //       toast.error('Failed to update status');
  //     });
  // };

  // Function to toggle showParents
  const toggleParents = (id, fixtureId) => {
    setShowParents((prevState) => {
      // Create a new object to hold the updated state
      const updatedState = {};

      // Iterate through all keys in prevState
      Object.keys(prevState).forEach((key) => {
        // Toggle the specified id and set all other ids to false
        updatedState[key] = Number(key) === id ? !prevState[key] : false;
      });

      // Ensure the specified id is set to true if it was previously false or does not exist
      if (!prevState[id]) {
        updatedState[id] = true;
      }

      return updatedState;
    });

    // Incident
    getCourseFixtureIncidents(fixtureId);
  };

  // Function to highlight rows
  const handleHighlight = (index) => {
    const newHighlighted = [...highlighted];
    newHighlighted[index] = !newHighlighted[index];
    setHighlighted(newHighlighted);
  };

  // Function to create a new course
  const createCourse = (data) => {
    // If the color is not selected, set it to the default color #004d26
    if (!data.color || data.color.trim() === "") {
      data.color = "#004d26"; // Set default color
    }

    dispatch(addCourse({ data, navigate, setLoader })).then(() => {
      setModalShow({ show: false, id: "" });
      dispatch(courseList({ navigate, setLoader, locationId }));
    });
  };

  // Function to edit an existing course
  const editCourse = async (data) => {
    try {

      const { id, courseId } = modalShow || {}; // Safely destructure modalShow
      if (!id || !courseId) {
        console.error("Invalid modalShow data:", modalShow);
        return;
      }

      // Dispatch the update course action
      await dispatch(updateCourse({ id, data, courseId, navigate, setLoader, locationId }));

      // Reset modal state
      setModalShow({ show: false, id: "", courseId: "" });

      // Clear course data
      await dispatch(setClearCourseData());

      // Reload course list
      dispatch(courseList({ navigate, setLoader, locationId }));

    } catch (error) {
      console.error("Error updating course:", error);
    }
  };

  // Function to remove a course
  const removeCourse = (id) => {
    dispatch(deleteCourse({ id, navigate, setLoader, locationId })).then(() => {
      dispatch(courseList({ navigate, setLoader, locationId }));
    });
    setDeleteModal({ show: false });
  };

  const removeQuest = (courseId, incidentTypeId) => {
    dispatch(deleteQuest({ courseId, incidentTypeId, navigate, setLoader })).then(() => {
      dispatch(courseList({ navigate, setLoader, locationId }));
      dispatch(getIncidentTypes({ courseId, navigate, setLoader }));
    });
    setDeleteModal({ show: false });
  };

  // Copy Quest - creates a new CourseGroup + Course with only the copied quest
  const handleCopyQuest = (name, color) => {
    if (!copyQuestModalShow.courseId || !copyQuestModalShow.incidentTypeId) {
      toast.error("Invalid quest selection");
      return;
    }

    dispatch(
      copyQuest({
        courseId: copyQuestModalShow.courseId,
        incidentTypeId: copyQuestModalShow.incidentTypeId,
        name,
        color,
        locationId,
        navigate,
        setLoader,
      })
    ).then((result) => {
      if (result.payload?.course) {
        toast.success(`Quest "${name}" copied successfully!`);
        dispatch(courseList({ navigate, setLoader, locationId }));
      }
      setCopyQuestModalShow({ show: false, courseId: "", incidentTypeId: "", incidentTypeName: "" });
    });
  };

  // Clone Course Group (Quest Area) - clones the entire CourseGroup with all quests
  const handleCloneCourseGroup = (startingMarker, color) => {
    if (!cloneCourseGroupModalShow.courseGroupId) {
      toast.error("Invalid quest area selection");
      return;
    }

    dispatch(
      cloneCourseGroup({
        courseGroupId: cloneCourseGroupModalShow.courseGroupId,
        locationId,
        startingMarker,
        color,
        navigate,
        setLoader,
      })
    ).then((result) => {
      if (result.payload?.course_group || result.payload?.id) {
        toast.success(`Quest Area cloned successfully!`);
        dispatch(courseList({ navigate, setLoader, locationId }));
      }
      setCloneCourseGroupModalShow({ show: false, courseGroupId: "", courseGroupName: "", defaultStartingMarker: "" });
    });
  };

  // Function to handle the API call and related actions - now per-quest
  const handleTestCourseClick = (courseId, incidentTypeId) => {
    dispatch(testCourse({ courseId, incidentTypeId, navigate, setLoader }))
      .then((result) => {
        // console.log("result", result);

        if (result.payload?.uuid && result.payload?.qrcodeurl) {
          // Set modal state with QR code data
          setTestQRShow({
            show: true,
            uuid: result.payload.uuid,
            qrcodeurl: result.payload.qrcodeurl,
          });

          // Clear course data and refresh course list
          dispatch(setClearCourseData());
          dispatch(courseList({ navigate, setLoader, locationId }));
        } else {
          console.error(
            "Invalid response payload: Missing UUID or QR code URL."
          );
        }
      })
      .catch((error) => {
        console.error("Error testing course:", error);
      });
  };

  // Function to get all fixtures
  const getFixtures = () => {
    dispatch(getAllFixture({ setLoader }));
  };

  // const publishCourseApi = async (id) => {
  //   const result = await dispatch(publishCourse({ id, setLoader }));
  // };

  const publishCourseApi = async (id) => {
    const result = await dispatch(publishCourse({ id, navigate, setLoader }));
    if (result.payload.url) {
      const link = document.createElement("a");
      link.href = result.payload.url;
      link.download = `zone_${result.payload.id}.zip`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  // Download SCORM - now per-quest
  const downloadScorm = async (courseId, incidentTypeId, gps, cName, isTest = true) => {
    console.log('cName', cName);

    const result = await dispatch(
      downloadCourse({ courseId, incidentTypeId, test: isTest, navigate, setLoader })
    );

    if (result.payload?.url) {
      const link = document.createElement("a");
      link.href = result.payload.url;

      // Check gps value and set filename accordingly
      const filename = gps === 1
        ? `${cName}_GPS_SCORM.zip`
        : `${cName}_SCORM.zip`;

      link.download = filename; // Set the filename dynamically
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setDownloadModal({ show: false });
  };

  const [apiResponse, setApiResponse] = useState(null);

  // Publish Quest API - now per-quest
  const printCourseApi = async (courseId, courseName, testKey, incidentTypeId) => {
    try {
      // Set the loader to true before starting the API call
      setLoader(true);

      const result = await dispatch(
        printCourse({ courseId, incidentTypeId, testKey, navigate, setLoader })
      );

      // Determine the modal content based on testKey
      const modalContent = {
        show: true,
        html: result.payload?.html || '',
        cclink: testKey ? result.payload?.testlink : result.payload?.cclink,
        ccqrcodeurl: testKey ? result.payload?.testqrcodeurl : result.payload?.ccqrcodeurl,
        id: courseId,
        name: courseName,
        testKey,
        incidentTypeId
      };

      // Show the modal with the determined content
      setPrintModalShow(modalContent);

      // Stop the loader after showing the modal
      setLoader(false);

      // Preload images before continuing
      if (result.payload?.html) {
        const preloadedHtml = await preloadImages(result.payload.html);

        // Extract locationName, startingMarkerName and selectedIncidentTypes from the API response
        const locationName = result.payload.locationName || '';
        const startingMarkerName = result.payload.startingMarkerName || '';
        const selectedIncidentTypes = result.payload.selectedIncidentTypes || [];

        // Call the appropriate print function
        printContent(preloadedHtml, courseId, courseName, testKey, locationName, startingMarkerName, selectedIncidentTypes);
      }
    } catch (error) {
      console.error("Error in printCourseApi:", error);
      setLoader(false); // Close the loader in case of error
    }
  };

  // Preload images to ensure they are fully loaded before printing
  const preloadImages = (htmlContent) => {
    return new Promise((resolve) => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlContent;

      const images = tempDiv.querySelectorAll("img");
      let imagesLoaded = 0;

      const checkImagesLoaded = () => {
        imagesLoaded++;
        if (imagesLoaded === images.length) {
          resolve(tempDiv.innerHTML);
        }
      };

      if (images.length === 0) {
        resolve(tempDiv.innerHTML);
      }

      for (let img of images) {
        const tempImg = new Image();
        tempImg.src = img.src;

        tempImg.onload = checkImagesLoaded;
        tempImg.onerror = checkImagesLoaded;
      }
    });
  };

  const printContent = (htmlContent, courseId, courseName, testKey, locationName, startingMarkerName, selectedIncidentTypes) => {
    setLoader(false);

    // Get max 3 incident types and join them
    const incidentTypesStr = (selectedIncidentTypes || []).slice(0, 3).join(', ');

    // Open content in a new tab or window
    const printWindow = window.open("", "_blank", "width=800, height=600");

    if (printWindow) {
      const html = `
              <html>
                <head>
                  <title>${locationName}-${startingMarkerName}-${incidentTypesStr}</title>
                  <style>
                    @media print {
                      @page {
                        margin: 0; /* Remove browser-added headers and footers */
                      }
                      .pagebreak { 
                        page-break-before: always; 
                      }
                    }
                  </style>
                </head>
                <body>${htmlContent}</body>
              </html>
            `;

      const doc = printWindow.document;
      doc.open();
      doc.write(html);
      doc.close();

      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();

        // Close window automatically for non-test scenarios
        if (!testKey) {
          printWindow.close();
        }
      };
    } else {
      console.error("Failed to open print window.");
      setLoader(false); // Close the loader if the print window fails to open
    }
  };

  // Function to get fixtures for a particular course
  const getCourseFixtures = (id, type, ZoneAssembly) => {
    // Value True
    setCheckedState({ [id]: true });
    setShowDetails({ [id]: true });

    dispatch(getFixture({ id, navigate, setLoader })).then((item) => {
      // console.log('getFixture');
      if (type === "addAndEdit") {
        openFixtureModal(
          id,
          `${item?.payload?.courseFixtures?.length > 0 ? "edit" : "add"}`,
          ZoneAssembly
        );
      }
    });
  };

  const getQuestListing = (id, type) => {
    dispatch(getIncidentTypes({ courseId: id, navigate, setLoader }))
      .then((item) => {
        console.log("itemitem", item?.payload?.incidentTypes);

        if (type === "addAndEdit") {
          openQuestModal(
            id,
            `${item?.payload?.incidentTypes?.length > 0 ? "edit" : "add"}`
          );
        }
      });
  };

  // Function to get fixtures for a particular course
  const getCourseFixtureIncidents = (id) => {
    dispatch(getCourseFixtureIncident({ navigate, id, setLoader }));
  };

  // Function to remove a fixture
  const removeCourseFixture = (id) => {
    const selectedCourseId = location?.state?.zone?.zoneId || "";

    dispatch(
      deleteCourseFixture({ id, navigate, setLoader, selectedCourseId })
    ).then(() => {
      // dispatch(courseList({ setLoader, locationId }));
    });
    setDeleteModal({ show: false });
  };

  // Effect to reset form values and clear errors when the modal is closed
  useEffect(() => {
    if (!modalShow.show) {
      setValue("starting_marker", "");
      setValue("name", "");
      setValue("hint", "");
      setValue("notes", "");
      setValue("color", "");
      clearErrors();
    }
  }, [modalShow.show, setValue, clearErrors]);

  // const isDisabledAddBtn = zoneData?.data?.length < 1;

  // console.log('isDisabledAddBtn', isDisabledAddBtn);
  // console.log('zoneData length', zoneData?.data?.length);

  useEffect(() => {
    if (courseData?.data) {
      const newColors = courseData.data.map((courseTable) => {
        const myColor = courseTable.color?.startsWith("#")
          ? courseTable.color
          : `#${courseTable.color}`;
        return {
          main: myColor,
          light: tinycolor(myColor).lighten(40).toString(),
          lighten: tinycolor(myColor).lighten(100).toString(),
          bright: tinycolor(myColor).brighten(15).toString(),
          brighter: tinycolor(myColor).brighten(30).toString(),
          dark: tinycolor(myColor).darken(15).toString(),
          darker: tinycolor(myColor).darken(30).toString(),
        };
      });
      setColors(newColors);
    }
  }, [courseData?.data]);

  const getContrastColor = (hexColor) => {
    if (!hexColor) return "#000000"; // Fallback color if hexColor is undefined
    let color = hexColor.startsWith("#") ? hexColor : `#${hexColor}`; // Add # if missing
    if (color.length !== 7) return "#000000"; // Invalid color fallback

    const r = parseInt(color.substring(1, 3), 16);
    const g = parseInt(color.substring(3, 5), 16);
    const b = parseInt(color.substring(5, 7), 16);

    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
    return luminance > 150 ? "#000000" : "#ffffff";
  };

  const [selectedColor, setSelectedColor] = useState("");

  const colorsss = [
    { value: "fff2cc", label: "fff2cc" },
    { value: "00FF00", label: "00FF00" },
    { value: "f49915", label: "f49915" },
    { value: "f34a23", label: "f34a23" },
    { value: "f4002a", label: "f4002a" },
    { value: "a00051", label: "a00051" },
    { value: "8600b0", label: "8600b0" },
    { value: "4800a6", label: "4800a6" },
    { value: "441efd", label: "441efd" },
    { value: "3d8ecd", label: "3d8ecd" },
    { value: "69b42e", label: "69b42e" },
    { value: "ccf020", label: "ccf020" },
  ].reverse();

  const handleChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedColor(selectedValue);
    setValue("color", selectedValue); // Update form value when selecting a color
  };

  // Canvas Show
  // useEffect(() => {
  //   if (printModalShow.show) {
  //     drawHouse();
  //     drawBus();
  //   }
  // }, [printModalShow.show]);

  const drawHouse = () => {
    const canvas = houseCanvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    // Set background color (fixes transparency issue)
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.lineWidth = 5;
    ctx.strokeStyle = "black";
    ctx.fillStyle = "brown";

    // Wall
    ctx.strokeRect(75, 140, 150, 110);

    // Door
    ctx.fillStyle = "darkred";
    ctx.fillRect(130, 190, 40, 60);

    // Roof
    ctx.beginPath();
    ctx.moveTo(50, 140);
    ctx.lineTo(150, 60);
    ctx.lineTo(250, 140);
    ctx.closePath();
    ctx.stroke();
  };

  const drawBus = () => {
    const canvas = busCanvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    // Set background color (fixes transparency issue)
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Bus body
    ctx.fillStyle = "yellow";
    ctx.fillRect(50, 100, 200, 80);
    ctx.strokeStyle = "black";
    ctx.strokeRect(50, 100, 200, 80);

    // Windows
    ctx.fillStyle = "blue";
    ctx.fillRect(60, 110, 40, 30);
    ctx.fillRect(110, 110, 40, 30);
    ctx.fillRect(160, 110, 40, 30);

    // Wheels
    ctx.fillStyle = "black";
    ctx.beginPath();
    ctx.arc(80, 190, 15, 0, Math.PI * 2);
    ctx.fill();
    ctx.beginPath();
    ctx.arc(200, 190, 15, 0, Math.PI * 2);
    ctx.fill();

    // Door
    ctx.fillStyle = "darkgray";
    ctx.fillRect(190, 130, 30, 50);
  };

  const downloadZip = () => {
    const zip = new JSZip(); // Assuming you have JSZip available to create a zip
    const houseCanvas = houseCanvasRef.current;
    const busCanvas = busCanvasRef.current;

    if (houseCanvas && busCanvas) {
      // Convert canvas to image blobs
      houseCanvas.toBlob((houseBlob) => {
        zip.file("house.png", houseBlob);

        busCanvas.toBlob((busBlob) => {
          zip.file("bus.png", busBlob);

          // Generate the zip file and trigger download
          zip.generateAsync({ type: "blob" }).then((content) => {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(content);
            link.download = "canvas_images.zip";
            link.click();
          });
        });
      });
    }
  };

  // Copy Quest Form Component
  const CopyQuestForm = ({ onSubmit, onCancel, defaultName }) => {
    const [questName, setQuestName] = useState(defaultName || "");
    const [questColor, setQuestColor] = useState("");

    const colorOptions = [
      { value: "fff2cc", label: "Light Yellow" },
      { value: "00FF00", label: "Green" },
      { value: "f49915", label: "Orange" },
      { value: "f34a23", label: "Red Orange" },
      { value: "f4002a", label: "Red" },
      { value: "a00051", label: "Maroon" },
      { value: "8600b0", label: "Purple" },
      { value: "4800a6", label: "Violet" },
      { value: "441efd", label: "Blue" },
      { value: "3d8ecd", label: "Light Blue" },
      { value: "69b42e", label: "Lime" },
      { value: "ccf020", label: "Yellow Green" },
    ].reverse();

    const handleFormSubmit = (e) => {
      e.preventDefault();
      if (!questName.trim()) {
        toast.error("Quest name is required");
        return;
      }
      if (questName.length > 100) {
        toast.error("Quest name must be 100 characters or less");
        return;
      }
      onSubmit(questName, questColor ? `#${questColor}` : null);
    };

    return (
      <form onSubmit={handleFormSubmit}>
        <div className="row">
          <div className="col-lg-12">
            <div className="form-group mt-4">
              <label htmlFor="quest-name" className="innerlable">
                New Quest Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter quest name"
                maxLength={100}
                id="quest-name"
                value={questName}
                onChange={(e) => setQuestName(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-group mt-4">
              <label className="innerlable">
                Select Color (Optional)
              </label>
              <br />
              <div className="color-checkboxes">
                {colorOptions.map((col) => (
                  <label key={col.value} className="color-option">
                    <input
                      type="radio"
                      name="questColor"
                      value={col.value}
                      onChange={(e) => setQuestColor(e.target.value)}
                      checked={questColor === col.value}
                      style={{ display: "none" }}
                    />
                    <span
                      className={`color-circle shadow-lg ${questColor === col.value ? "checked" : ""}`}
                      style={{ backgroundColor: `#${col.value}` }}
                      title={col.label}
                    />
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center mt-5">
          <button type="submit" className="submit_btn">
            Copy Quest
          </button>
          <button type="button" className="cancleBtn" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </form>
    );
  };

  // Clone Course Group Form Component
  const CloneCourseGroupForm = ({ onSubmit, onCancel, defaultStartingMarker }) => {
    const [startingMarker, setStartingMarker] = useState(defaultStartingMarker || "");
    const [groupColor, setGroupColor] = useState("");

    const colorOptions = [
      { value: "fff2cc", label: "Light Yellow" },
      { value: "00FF00", label: "Green" },
      { value: "f49915", label: "Orange" },
      { value: "f34a23", label: "Red Orange" },
      { value: "f4002a", label: "Red" },
      { value: "a00051", label: "Maroon" },
      { value: "8600b0", label: "Purple" },
      { value: "4800a6", label: "Violet" },
      { value: "441efd", label: "Blue" },
      { value: "3d8ecd", label: "Light Blue" },
      { value: "69b42e", label: "Lime" },
      { value: "ccf020", label: "Yellow Green" },
    ].reverse();

    const handleFormSubmit = (e) => {
      e.preventDefault();
      if (!startingMarker.trim()) {
        toast.error("Starting marker is required");
        return;
      }
      if (startingMarker.length > 100) {
        toast.error("Starting marker must be 100 characters or less");
        return;
      }
      if (!groupColor) {
        toast.error("Color is required");
        return;
      }
      onSubmit(startingMarker, `#${groupColor}`);
    };

    return (
      <form onSubmit={handleFormSubmit}>
        <div className="row">
          <div className="col-lg-12">
            <div className="form-group mt-4">
              <label htmlFor="starting-marker" className="innerlable">
                New Starting Marker <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter starting marker name"
                maxLength={100}
                id="starting-marker"
                value={startingMarker}
                onChange={(e) => setStartingMarker(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-group mt-4">
              <label className="innerlable">
                Select Color <span className="text-danger">*</span>
              </label>
              <br />
              <div className="color-checkboxes">
                {colorOptions.map((col) => (
                  <label key={col.value} className="color-option">
                    <input
                      type="radio"
                      name="groupColor"
                      value={col.value}
                      onChange={(e) => setGroupColor(e.target.value)}
                      checked={groupColor === col.value}
                      style={{ display: "none" }}
                    />
                    <span
                      className={`color-circle shadow-lg ${groupColor === col.value ? "checked" : ""}`}
                      style={{ backgroundColor: `#${col.value}` }}
                      title={col.label}
                    />
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between align-items-center mt-5">
          <button type="submit" className="submit_btn">
            Clone Quest Area
          </button>
          <button type="button" className="cancleBtn" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </form>
    );
  };

  return (
    <>
      <div className="org">
        <div className="org_header d-flex align-items-center justify-content-between">
          <h1 className="org_header_heading">Quests</h1>
          <button
            type="button"
            className="submit_btn"
            style={lockedStyle}
            disabled={isLocationLocked}
            // className={`submit_btn ${isDisabledAddBtn ? '' : 'disabled pointer-none'}`}
            onClick={() => {
              if (isLocationLocked) return;
              setValue("color", " "); // Clear the form's color value
              setSelectedColor(""); // Clear the component's color state
              setModalShow({ show: true });
            }}
          >
            + Create Quest Area
          </button>
        </div>
        {isLocationLocked && (
          <style>{`
            .courses-listing-locked button,
            .courses-listing-locked input,
            .courses-listing-locked label,
            .courses-listing-locked .toggle-group,
            .courses-listing-locked img.cursor {
              pointer-events: none !important;
              opacity: 0.5 !important;
            }
            .courses-listing-locked label.check_box,
            .courses-listing-locked label.check_box *,
            .courses-listing-locked .check_box,
            .courses-listing-locked .check_box * {
              pointer-events: auto !important;
              opacity: 1 !important;
            }
          `}</style>
        )}
        <div className={isLocationLocked ? "courses-listing-locked" : ""}>
        <InfiniteScroll
          fetchMoreData={() => fetchMoreCourses(0)}
          hasMore={hasMore}
          isLoading={courseStatus === "loading"}
          threshold={200}
        >
          {courseData?.data?.map((courseTable, tableIndex) => {
            const color = colors[tableIndex] || { main: "#ffffff" }; // Default to white if color is not found
            const textColor = getContrastColor(color.main);

            return (
              <Fragment key={courseTable.id}>
                <div className="org_table table-border-0 table-responsive">
                  <table className="table position-relative">
                    <thead>
                      <tr>
                        <td
                          style={{
                            backgroundColor: color.main,
                            color: textColor,
                          }}
                          className="org_table_column w-5"
                        ></td>
                        <td
                          style={{
                            backgroundColor: color.main,
                            color: textColor,
                          }}
                          className="org_table_column w-20"
                        >
                          Quest Area's Marker Name
                        </td>
                        <td
                          style={{
                            backgroundColor: color.main,
                            color: textColor,
                          }}
                          className="org_table_column w-20"
                        >
                          Hint
                        </td>
                        <td
                          style={{
                            backgroundColor: color.main,
                            color: textColor,
                          }}
                          className="org_table_column w-20"
                        >
                          Notes
                        </td>
                        {locationType === "location" && (
                          <td
                            style={{
                              backgroundColor: color.main,
                              color: textColor,
                            }}
                            className="org_table_column w-15"
                          >
                            Assembly Points
                          </td>
                        )}
                        {/* <td
                          style={{
                            backgroundColor: color.main,
                            color: textColor,
                          }}
                          className="org_table_column w-10"
                        >
                          GPS
                        </td> */}
                        <td
                          style={{
                            backgroundColor: color.main,
                            color: textColor,
                          }}
                          className="org_table_column w-35 text-center"
                        >
                          Action
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {courseTable?.courses?.map((course, courseIndex) => {
                        console.log("course===>", course);
                        return (
                          <Fragment key={course.id}>
                            <tr key={course.id}>
                              <td
                                style={{ backgroundColor: color.light }}
                                className="org_table_row w-5"
                              >
                                <label
                                  className="check_box ml-2"
                                  htmlFor={`checkbox-${course.id}`}
                                >
                                  <input
                                    type="checkbox"
                                    id={`checkbox-${course.id}`}
                                    checked={checkedState[course.id] || false}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        course.id,
                                        course.name,
                                        course.starting_marker
                                      )
                                    }
                                  />
                                  <span
                                    style={{
                                      backgroundColor: checkedState[course.id] ? color.main : "",
                                      border: checkedState[course.id] ? `2px solid ${color.main}` : "",
                                    }}
                                    className="checkbox_check_course"
                                  ></span>
                                </label>
                              </td>
                              <td
                                style={{ backgroundColor: color.light }}
                                className="org_table_row w-20 incident-type-name"
                              >
                                {course?.starting_marker}
                              </td>
                              <td
                                style={{ backgroundColor: color.light }}
                                className="org_table_row w-20 incident-type-name"
                              >
                                {course?.hint}
                              </td>
                              <td
                                style={{ backgroundColor: color.light }}
                                className="org_table_row w-20 incident-type-name"
                              >
                                {course?.notes}
                              </td>
                              {locationType === "location" && (
                                <td
                                  style={{ backgroundColor: color.light }}
                                  className="org_table_row w-15 incident-type-name"
                                >
                                  {/* {location?.state?.assembly?.assemblyName} */}
                                  {course?.assembly_point?.name ? (
                                    <>
                                      {course?.assembly_point?.name}

                                      {/* <button type='button' className='action_btns mr-4' onClick={() => {
                                        setAssemblyModalShow({ show: true, title: "Edit", id: course.id, locationId: course.location_id, assemblyPointId: course?.assembly_point?.id })
                                        setValueAssembly('newAssemblyName', course?.assembly_point?.name)
                                      }}>
                                        <img src={editGreenImg} alt='' className='mr-1' /> { }
                                      </button> */}

                                      <img
                                        src={editGreenImg}
                                        alt=""
                                        className="ml-1 cursor"
                                        onClick={() => {
                                          setAssemblyModalShow({
                                            show: true,
                                            title: "Edit",
                                            courseId: course.id,
                                            locationId: course.location_id,
                                            assemblyId:
                                              course?.assembly_point?.id,
                                            assemblyName:
                                              course?.assembly_point?.name,
                                          });
                                          setValueAssembly(
                                            "newAssemblyName",
                                            course?.assembly_point?.name
                                          );
                                          setKey("home");
                                        }}
                                      />

                                      {/* <img src={deleteGreenImg} alt="" className='ml-1 cursor'
                                        onClick={() => setDeleteAssemblyModal({ show: true, courseId: course.id, assemblyId: course?.assembly_point?.id, assemblyName: course?.assembly_point?.name })}
                                      /> */}
                                    </>
                                  ) : (
                                    <button
                                      type="button"
                                      style={{ backgroundColor: color.darker }}
                                      className={`action_new_btn mr-2`}
                                      title="Add Assembly"
                                      onClick={() =>
                                        setAssemblyModalShow({
                                          show: true,
                                          title: "Add",
                                          courseId: course.id,
                                          locationId: course.location_id,
                                        })
                                      }
                                    >
                                      + Add Assembly
                                    </button>
                                  )}
                                </td>
                              )}
                              {/* <td
                                style={{ backgroundColor: color.light }}
                                className="org_table_row w-10"
                              >
                                <div className="toggle-group">
                                  <label className="switch">
                                    <input
                                      type="checkbox"
                                      className="d-none"
                                      checked={course?.gps || false}
                                      onChange={(e) => handleCheckboxClick(e, course?.id)}
                                    />
                                    <span
                                      className="togg-slide togg-round"
                                      style={{
                                        backgroundColor: course?.gps ? color.main : "#ccc",
                                        position: "relative",
                                      }}
                                    >
                                      <span
                                        className="toggle-text toggle-on"
                                        style={{
                                          position: "absolute",
                                          left: "10px",
                                          color: course?.gps ? "white" : "#999",
                                          fontWeight: course?.gps ? "bold" : "normal",
                                          transition: "color 0.3s ease",
                                        }}
                                      >
                                        On
                                      </span>
                                      <span
                                        className="toggle-text toggle-off"
                                        style={{
                                          position: "absolute",
                                          right: "10px",
                                          color: !course?.gps ? "white" : "#999",
                                          fontWeight: !course?.gps ? "bold" : "normal",
                                          transition: "color 0.3s ease",
                                        }}
                                      >
                                        Off
                                      </span>
                                    </span>
                                  </label>
                                </div>
                              </td> */}
                              <td
                                style={{ backgroundColor: color.light }}
                                className="org_table_row w-35"
                              >
                                <div
                                  className="d-flex flex-wrap align-items-center justify-content-center"
                                  style={{ gap: "10px" }}
                                >

                                  <button
                                    type="button"
                                    style={{ backgroundColor: color.darker }}
                                    className={`action_new_btn mr-2`}
                                    title="Edit"
                                    onClick={() => {
                                      setSelectedCourse(course);
                                      setModalShow({
                                        show: true,
                                        id: course.id,
                                        courseId: courseTable.id,
                                      });
                                      setValue("starting_marker", course.starting_marker);
                                      setValue("name", course.name);
                                      setValue("hint", course.hint);
                                      setValue("notes", course.notes);
                                      setValue("color", courseTable.color);
                                      setSelectedColor(courseTable.color);
                                    }}
                                  >
                                    <img src={editImg} alt="" className="" />
                                  </button>

                                  <button
                                    type="button"
                                    style={{ backgroundColor: color.darker }}
                                    className={`action_new_btn mr-2`}
                                    title="Clone Quest Area"
                                    onClick={() =>
                                      setCloneCourseGroupModalShow({
                                        show: true,
                                        courseGroupId: courseTable.id,
                                        courseGroupName: course.starting_marker || course.name || "Quest Area",
                                        defaultStartingMarker: course.starting_marker ? `${course.starting_marker} - Copy` : "",
                                      })
                                    }
                                  >
                                    <img src={copyImg} alt="" className="" />
                                  </button>

                                  <button
                                    type="button"
                                    style={{ backgroundColor: color.darker }}
                                    className={`action_new_btn mr-2`}
                                    title="Delete"
                                    // onClick={() => removeCourse(course.id)}
                                    onClick={() =>
                                      setDeleteModal({
                                        show: true,
                                        id: course.id,
                                        name: course.name,
                                        type: "course",
                                      })
                                    }
                                  >
                                    <img src={deleteImg} alt="" className="" />
                                  </button>

                                  <button
                                    type="button"
                                    className="action_new_btn mr-2"
                                    style={{ backgroundColor: color.darker }}
                                    onClick={() =>
                                      questModalApi(
                                        course.id
                                      )
                                    }
                                  >
                                    + Add Quest
                                  </button>

                                  {/* 30 Jan 2026 */}
                                  {/* {(course.gps !== 0 &&
                                    (course.course_fixtures_count > 0 ||
                                      (courseFixtureData?.length > 0 &&
                                        course.id === courseFixtureData[0].course_id))) && (
                                      <button
                                        type="button"
                                        className="action_new_btn bgBlack mr-2"
                                        title="Publish"
                                        onClick={() =>
                                          printCourseApi(
                                            course.id,
                                            course.name,
                                            false
                                          )
                                        }
                                      >
                                        Publish
                                      </button>
                                    )} */}

                                  {/* {(course.course_fixtures_count > 0 ||
                                    (courseFixtureData?.length > 0 && course.id === courseFixtureData[0].course_id)) &&
                                    course.gps !== 1 && (
                                      <button
                                        type="button"
                                        className="action_new_btn bgBlack mr-2"
                                        title="Take Test"
                                        onClick={() => handleTestCourseClick(course.id, true)}
                                      >
                                        Take Test
                                      </button>
                                    )} */}

                                  {/* 30 Jan 2026*/}
                                  {/* {(course.course_fixtures_count > 0 ||
                                    (courseFixtureData?.length > 0 && course.id === courseFixtureData[0].course_id)) &&
                                    course.gps !== 1 && (
                                      <button
                                        type="button"
                                        className="action_new_btn bgBlack mr-2"
                                        title="Take Test"
                                        onClick={() =>
                                          printCourseApi(
                                            course.id,
                                            course.name,
                                            true
                                          )
                                        }
                                      >
                                        Take Test
                                      </button>
                                    )} */}


                                  {/* 24 Feb 2026 */}
                                  {/* {(course.gps !== 0 &&
                                    (course.course_incident_types_count > 0)) && (
                                      <button
                                        type="button"
                                        className="action_new_btn bgBlack mr-2"
                                        title="Publish"
                                        onClick={() =>
                                          printCourseApi(
                                            course.id,
                                            // course.name,
                                            course.starting_marker,
                                            false
                                          )
                                        }
                                      >
                                        Publish
                                      </button>
                                    )}

                                  {(course.course_incident_types_count > 0) &&
                                    course.gps !== 1 && (
                                      <button
                                        type="button"
                                        className="action_new_btn bgBlack mr-2"
                                        title="Take Test"
                                        onClick={() =>
                                          printCourseApi(
                                            course.id,
                                            course.starting_marker,
                                            true
                                          )
                                        }
                                      >
                                        Take Test
                                      </button>
                                    )}

                                  {course?.course_recording_count > 0 && (
                                    <button
                                      type="button"
                                      className="action_new_btn bgBlack mr-2"
                                      title="Download Scorm"
                                      onClick={() =>
                                        downloadScorm(course.id, course.gps, course.starting_marker, course.gps === 0 ? true : false)
                                      }
                                    >
                                      Download Scorm
                                    </button>
                                  )} */}

                                </div>
                              </td>
                            </tr>

                            {showDetails[course.id] && (
                              <tr key={`details-${course.id}`}>
                                <td colSpan={12} className="pt-0 pl-0 pb-0">
                                  <div
                                    className={`table-responsive fixturePaddingCustom ${courseIncidentTypesData?.length > 5
                                      ? "fixtureTableInn"
                                      : "heightauto"
                                      }`}
                                  >
                                    <table className="w-100">
                                      <thead>
                                        <tr>
                                          <td
                                            style={{
                                              backgroundColor: color.main,
                                              color: textColor,
                                            }}
                                            className="org_table_column w-15"
                                          >
                                            Quest
                                          </td>
                                          <td
                                            style={{
                                              backgroundColor: color.main,
                                              color: textColor,
                                            }}
                                            className="org_table_column w-20"
                                          >
                                            Points of Interest
                                          </td>
                                          <td
                                            style={{
                                              backgroundColor: color.main,
                                              color: textColor,
                                            }}
                                            className="org_table_column w-25"
                                          >
                                            Prompts
                                          </td>
                                          <td
                                            style={{
                                              backgroundColor: color.main,
                                              color: textColor,
                                            }}
                                            className="org_table_column w-10"
                                          >
                                            GPS
                                          </td>
                                          <td
                                            style={{
                                              backgroundColor: color.main,
                                              color: textColor,
                                            }}
                                            className="org_table_column w-30 text-center"
                                          >
                                            Action
                                          </td>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {courseIncidentTypesData
                                          ?.filter((incidentType) => incidentType.selected)
                                          .map((incidentType) => (
                                            <Fragment key={incidentType.id}>
                                              <tr key={incidentType.id}>
                                                <td
                                                  style={{
                                                    backgroundColor: color.light,
                                                  }}

                                                  className="org_table_row_nested w-15"
                                                >
                                                  <div className="d-flex flex-column align-items-start">
                                                    {incidentType?.image && (
                                                      <img
                                                        src={`${process.env.REACT_APP_MEDIA_URL_ORG}${incidentType.image}`}
                                                        alt={incidentType.name}
                                                        className="quest-img-responsive"
                                                        style={{
                                                          width: '70px',
                                                          height: '70px',
                                                          minWidth: '60px',
                                                          minHeight: '60px',
                                                          maxWidth: '80px',
                                                          maxHeight: '80px',
                                                          objectFit: 'contain',
                                                          marginBottom: '8px'
                                                        }}
                                                      />
                                                    )}
                                                    <span className="incident-type-name">{incidentType?.name}</span>
                                                  </div>
                                                </td>
                                                <td
                                                  style={{
                                                    backgroundColor: color.light,
                                                  }}
                                                  className="org_table_row_nested w-20"
                                                >
                                                  <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", alignItems: "center" }}>
                                                    {incidentType?.fixtures?.map((fixture) => (
                                                      <img
                                                        key={fixture.id}
                                                        src={`${process.env.REACT_APP_MEDIA_URL_ORG}${fixture.image}`}
                                                        alt={fixture.name}
                                                        title={fixture.name}
                                                        className="quest-img-responsive"
                                                        style={{
                                                          width: "45px",
                                                          height: "45px",
                                                          minWidth: "35px",
                                                          minHeight: "35px",
                                                          maxWidth: "50px",
                                                          maxHeight: "50px",
                                                          objectFit: "contain",
                                                        }}
                                                      />
                                                    ))}
                                                  </div>
                                                </td>
                                                <td
                                                  style={{
                                                    backgroundColor: color.light,
                                                    padding: '12px 15px',
                                                    verticalAlign: 'top'
                                                  }}
                                                  className="org_table_row_nested w-25"
                                                >
                                                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                                    {incidentType?.incidents
                                                      ?.filter((incident) =>
                                                        incidentType.selected_incident_ids?.includes(incident.id)
                                                      )
                                                      .map((incident) => (
                                                        <div
                                                          key={incident.id}
                                                          className="incident-image"
                                                          style={{
                                                            background: `#F3F4F6`,
                                                            width: '150px',
                                                          }}
                                                        >
                                                          <div className="incident-image-portal">
                                                            <div className="incident-image-portal-text">
                                                              <div
                                                                className="incident-image-portal-text-name incident-type-name"
                                                                title={incident.name}
                                                              >
                                                                {incident.name?.length > 15
                                                                  ? `${incident.name.substring(0, 15)}...`
                                                                  : incident.name}
                                                              </div>
                                                              <p className="incident-image-portal-text-span incident-type-name">
                                                                {incidentType.name}
                                                              </p>
                                                            </div>
                                                          </div>
                                                          <img
                                                            src={`${process.env.REACT_APP_MEDIA_URL_ORG}${incident.image}`}
                                                            alt={incident.name}
                                                            className="exact-incident-img"
                                                          />
                                                        </div>
                                                      ))}
                                                  </div>
                                                </td>
                                                <td
                                                  style={{ backgroundColor: color.light }}
                                                  className="org_table_row_nested w-10"
                                                >
                                                  {/* GPS Toggle - now per-quest */}
                                                  <div className="toggle-group">
                                                    <label className="switch">
                                                      <input
                                                        type="checkbox"
                                                        className="d-none"
                                                        checked={incidentType?.gps || false}
                                                        onChange={(e) => handleGpsCheckboxClick(e, course?.id, incidentType.id)}
                                                      />
                                                      <span
                                                        className="togg-slide togg-round"
                                                        style={{
                                                          backgroundColor: incidentType?.gps ? color.main : "#ccc",
                                                          position: "relative",
                                                        }}
                                                      >
                                                        <span
                                                          className="toggle-text toggle-on"
                                                          style={{
                                                            position: "absolute",
                                                            left: "10px",
                                                            color: incidentType?.gps ? "white" : "#999",
                                                            fontWeight: incidentType?.gps ? "bold" : "normal",
                                                            transition: "color 0.3s ease",
                                                          }}
                                                        >
                                                          On
                                                        </span>
                                                        <span
                                                          className="toggle-text toggle-off"
                                                          style={{
                                                            position: "absolute",
                                                            right: "10px",
                                                            color: !incidentType?.gps ? "white" : "#999",
                                                            fontWeight: !incidentType?.gps ? "bold" : "normal",
                                                            transition: "color 0.3s ease",
                                                          }}
                                                        >
                                                          Off
                                                        </span>
                                                      </span>
                                                    </label>
                                                  </div>
                                                </td>
                                                <td style={{
                                                  backgroundColor: color.light,
                                                }}
                                                  className="org_table_row_nested w-30">
                                                  {/* Digital Only Toggle (Prompt-Search / Auto-Prompt) */}
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      gap: "6px",
                                                      marginBottom: "10px",
                                                    }}
                                                  >
                                                    <span style={{ fontWeight: "500", fontSize: "11px", whiteSpace: "nowrap", color: "#333" }}>Prompt-Search</span>
                                                    <label
                                                      style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        width: "40px",
                                                        height: "20px",
                                                        margin: 0,
                                                        cursor: "pointer",
                                                        flexShrink: 0,
                                                      }}
                                                    >
                                                      <input
                                                        type="checkbox"
                                                        style={{ display: "none" }}
                                                        checked={incidentType?.digital_only || false}
                                                        onChange={(e) =>
                                                          handleDigitalCheckboxClick(
                                                            e,
                                                            course?.id,
                                                            incidentType.id,
                                                            null
                                                          )
                                                        }
                                                      />
                                                      <span
                                                        style={{
                                                          position: "absolute",
                                                          top: 0,
                                                          left: 0,
                                                          right: 0,
                                                          bottom: 0,
                                                          backgroundColor: incidentType?.digital_only ? color.main : "#ccc",
                                                          borderRadius: "20px",
                                                          transition: "background-color 0.3s",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            position: "absolute",
                                                            top: "2px",
                                                            left: incidentType?.digital_only ? "22px" : "2px",
                                                            width: "16px",
                                                            height: "16px",
                                                            backgroundColor: "#fff",
                                                            borderRadius: "50%",
                                                            transition: "left 0.3s",
                                                            boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
                                                          }}
                                                        />
                                                      </span>
                                                    </label>
                                                    <span style={{ fontWeight: "500", fontSize: "11px", whiteSpace: "nowrap", color: "#333" }}>Auto-Prompt</span>
                                                  </div>

                                                  <div className="d-flex align-items-center justify-content-center">

                                                    {/* <button
                                                      type="button"
                                                      style={{ backgroundColor: color.darker }}
                                                      className={`action_new_btn mr-2`}
                                                      title="Copy Quest"
                                                      onClick={() =>
                                                        setCopyQuestModalShow({
                                                          show: true,
                                                          courseId: course?.id,
                                                          incidentTypeId: incidentType.id,
                                                          incidentTypeName: incidentType.name,
                                                        })
                                                      }
                                                    >
                                                      <img
                                                        src={copyImg}
                                                        alt=""
                                                        className=""
                                                      />
                                                    </button> */}

                                                    <button
                                                      type="button"
                                                      className="action_new_btn bgBlack mr-2"
                                                      title="Edit Quest"
                                                      onClick={() => questModalApi(course?.id)}
                                                    >
                                                      <img src={editImg} alt="" className="" />
                                                    </button>

                                                    <button
                                                      type="button"
                                                      className="action_new_btn bgBlack mr-2"
                                                      title="Delete Quest"
                                                      onClick={() =>
                                                        setDeleteModal({
                                                          show: true,
                                                          id: course.id,
                                                          incidentTypeId: incidentType.id,
                                                          name: `${incidentType.name} quest`,
                                                          type: "quest",
                                                        })
                                                      }
                                                    >
                                                      <img src={deleteImg} alt="" className="" />
                                                    </button>

                                                    {/* Show Publish Quest when GPS is enabled (gps === true) */}
                                                    {incidentType?.gps === true && (
                                                      <button
                                                        type="button"
                                                        className="action_new_btn bgBlack mr-2"
                                                        title="Publish Quest"
                                                        onClick={() => printCourseApi(course?.id, course?.starting_marker, false, incidentType.id)}
                                                      >
                                                        Publish Quest
                                                      </button>
                                                    )}
                                                    {/* Show Launch Quest when GPS is disabled (gps === false), take_test: true */}
                                                    {incidentType?.gps === false && (
                                                      <button
                                                        type="button"
                                                        className="action_new_btn bgBlack mr-2"
                                                        title="Launch Quest"
                                                        onClick={() => printCourseApi(course?.id, course?.starting_marker, true, incidentType.id)}
                                                      >
                                                        Launch Quest
                                                      </button>
                                                    )}
                                                    {/* Show Download SCORM when quest has been recorded */}
                                                    {incidentType?.recorded === true && (
                                                      <button
                                                        type="button"
                                                        className="action_new_btn bgBlack mr-2"
                                                        title="Download SCORM"
                                                        onClick={() => downloadScorm(course?.id, incidentType.id, incidentType?.gps ? 1 : 0, course?.starting_marker, !incidentType?.gps)}
                                                      >
                                                        Download SCORM
                                                      </button>
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                            </Fragment>
                                          ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </Fragment>
            );
          })}
        </InfiniteScroll>
        </div>
      </div>

      {/* Add Course */}
      <CustomModal
        show={modalShow.show}
        onHide={() => setModalShow({ show: false })}
        heading={modalShow.id ? "Edit Quest Area" : "Create Quest Area"}
        size="md"
        body={
          <form
            onSubmit={
              modalShow.id
                ? handleSubmit(editCourse)
                : handleSubmit(createCourse)
            }
          >
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group mt-4">
                  <label htmlFor="Start-maker-name" className="innerlable">
                    Name this quest area's marker (max 24 characters)
                  </label>
                  <input
                    type="text"
                    // className={`form-control ${selectedCourse?.cloned === 1 ? "not-allowed" : ""}`}
                    className="form-control"
                    placeholder="Ex: Reception Desk"
                    maxLength={24}
                    id="Start-maker-name"
                    // disabled={selectedCourse?.cloned === 1}
                    {...register("starting_marker", { required: "quest area's marker name required" })}
                  />
                  {errors.starting_marker && (
                    <p className="text-danger">{errors.starting_marker.message}</p>
                  )}
                </div>
              </div>
              {/* <div className="col-lg-12">
                <div className="form-group mt-4">
                  <label htmlFor="zone-name" className="innerlable">
                    Quest Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Quest Name"
                    maxLength={24}
                    id="zone-name"
                    {...register("name", { required: "Quest name required" })}
                  />
                  {errors.name && (
                    <p className="text-danger">{errors.name.message}</p>
                  )}
                </div>
              </div> */}
              <div className="col-lg-12">
                <div className="form-group mt-4">
                  <label htmlFor="zone-hint" className="innerlable">
                    Hint (max 150 characters)
                  </label>
                  <textarea
                    className="form-control"
                    id="zone-hint"
                    rows="5"
                    maxLength={150}
                    placeholder="Ex: The Start marker is at the Reception Desk"
                    {...register("hint", { required: "Hint required" })}
                  ></textarea>
                  {errors.hint && (
                    <p className="text-danger">{errors.hint.message}</p>
                  )}
                </div>
              </div>
              <div className="col-lg-12">
                <div className="form-group mt-4">
                  <label htmlFor="zone-notes" className="innerlable">
                    Notes (optional, max 250 characters)
                  </label>
                  <textarea
                    className="form-control"
                    id="zone-notes"
                    rows="5"
                    maxLength={250}
                    placeholder="Ex: Known as Zone 2A South on fire map"
                    {...register("notes", {})}
                  ></textarea>
                  {/* <textarea className="form-control" id="zone-notes" rows="5" maxLength={250} placeholder='Max. 250 characters' {...register('notes', { required: 'Notes required' })}></textarea> */}
                  {errors.notes && (
                    <p className="text-danger">{errors.notes.message}</p>
                  )}
                </div>
              </div>
              {/* <div className="col-lg-12">
                <div className="form-group mt-4">
                  <label htmlFor="zone-notes" className='innerlable'>Select Color</label>
                  <br></br>
                  <input type="color" id="favcolor" name="color" {...register('color')} />
                </div>
              </div> */}

              {/* <div className="col-lg-12">
                <div className="form-group mt-4">
                  <label htmlFor="favcolor" className="innerlable">Select Color</label>
                  <br />
                  <select
                    id="favcolor"
                    name="color"
                    className="form-control"
                    {...register('color')}
                    value={selectedColor}
                    onChange={handleChange}
                    style={{ backgroundColor: selectedColor, color: selectedColor === '#000000' ? '#fff' : '#000' }}
                  >
                    {colorss.map(color => (
                      <option key={color.value} value={color.value} style={{ backgroundColor: color.value, color: '#000' }}>
                        {color.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div> */}

              {!modalShow.id && (
                <div className="col-lg-12">
                  <div className="form-group mt-4">
                    <label htmlFor="favcolor" className="innerlable">
                      Select Color
                    </label>
                    <br />
                    <div className="color-checkboxes">
                      {/* {colorsss.map(col => (
                        <label key={col.value} className="color-option">
                          <input
                            type="radio"
                            {...register('color', { required: 'Color is required' })}
                            checked={watch('color') === col.value}
                            style={{ display: 'none' }}
                          />
                          <span
                            className={`color-circle ${watch('color') === col.value ? 'checked' : ''}`}
                            style={{ backgroundColor: col.value }}
                            title={col.label}
                          />
                        </label>
                      ))} */}

                      {colorsss.map((col) => (
                        <label key={col.value} className="color-option">
                          <input
                            type="radio"
                            name="color"
                            value={col.value}
                            onChange={handleChange} // Call handleChange to update both state and form
                            checked={selectedColor === col.value} // Sync state with the radio button
                            style={{ display: "none" }}
                          />
                          <span
                            className={`color-circle shadow-lg ${selectedColor === col.value ? "checked" : ""
                              }`}
                            // style={{ backgroundColor: col.value }}
                            style={{ backgroundColor: `#${col.value}` }}
                            title={col.label}
                          />
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <CustomBtn
              buttonText="Save"
              className="mt-5"
              type="submit"
              id="campusName"
            />
          </form>
        }
      />

      {/* Assembly Add */}
      <CustomModal
        show={assemblyModalShow.show}
        onHide={() => setAssemblyModalShow({ show: false })}
        heading={
          assemblyModalShow.title === "Add"
            ? "Add Assembly Point"
            : "Edit Assembly Point"
        }
        size="md"
        body={
          <form
            onSubmit={
              assemblyModalShow.title === "Add"
                ? handleSubmitAssembly(createAssembly)
                : handleSubmitAssembly(editAssembly)
            }
          >
            <div className="row">
              <div className="col-lg-12">
                <Tabs
                  id="justify-tab-example"
                  className="mb-3"
                  justify
                  activeKey={key}
                  onSelect={(k) => {
                    if (assemblyModalShow.title === "Add") {
                      // Check if title is "Add"
                      setValueAssembly("newAssemblyName", "");
                    }
                    setValueAssembly("existingAssemblyName", "");
                    setKey(k); // Proceed with tab switch if the field is not empty
                  }}
                // onSelect={(k) => setKey(k)}
                >
                  <Tab
                    eventKey="home"
                    title={
                      assemblyModalShow.title === "Add" ? "Create" : "Update"
                    }
                  >
                    <div className="form-group">
                      <label className="innerlable">Assembly Point</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="type here"
                        maxLength={30}
                        {...registerAssembly("newAssemblyName")} // <-- Use a unique field name for "Create New"
                        onChange={(e) =>
                          setValueAssembly("newAssemblyName", e.target.value)
                        } // <-- Update the correct field
                      />
                      {errorsAssembly.newAssemblyName && (
                        <p className="text-danger">
                          {errorsAssembly.newAssemblyName.message}
                        </p>
                      )}
                    </div>

                    <div>
                      <CustomBtn
                        buttonText="Save"
                        className="mt-5"
                        type="submit"
                        id="assemblyName"
                      />

                      {assemblyModalShow?.title === "Edit" && (
                        <CustomBtn
                          buttonText="Remove"
                          className="removeBtn ml-5"
                          type="button"
                          id="assemblyName"
                          onClick={() =>
                            setDeleteAssemblyModal({
                              show: true,
                              courseId: assemblyModalShow.courseId,
                              assemblyId: assemblyModalShow.assemblyId,
                              assemblyName: assemblyModalShow.assemblyName,
                            })
                          }
                        />
                      )}
                    </div>
                  </Tab>
                  <Tab eventKey="profile" title="Existing">
                    <div className="form-group">
                      <label className="innerlable">Assembly Point</label>
                      <select
                        className="form-control custom-select"
                        {...registerAssembly("existingAssemblyName")} // <-- Use a different field name for "Existing"
                        onChange={(e) => {
                          const selectedOption = assemblyListing.find(
                            (asem) => asem.name === e.target.value
                          );
                          setSelectedAssemblyId(
                            selectedOption ? selectedOption.id : ""
                          );
                          setValueAssembly(
                            "existingAssemblyName",
                            e.target.value
                          );
                        }}
                      >
                        <option value="">Select Assembly Point</option>
                        {assemblyListing?.map((asem, index) => {
                          return (
                            <option
                              key={`catWithoutPagi_${index}`}
                              value={asem?.name}
                            >
                              {asem?.name}
                            </option>
                          );
                        })}
                      </select>
                      {errorsAssembly.existingAssemblyName && (
                        <p className="text-danger">
                          {errorsAssembly.existingAssemblyName?.message}
                        </p>
                      )}
                    </div>
                    <div>
                      {/* <CustomBtn
                        buttonText="Save"
                        className="mt-5"
                        type="submit"
                        id="assemblyName"
                      /> */}

                      <CustomBtn
                        buttonText="Save"
                        className="mt-5"
                        type="button"
                        id="assemblyName"
                        onClick={() =>
                          existAssembly({
                            courseId: assemblyModalShow.courseId,
                            assemblyId: selectedAssemblyId,
                            assemblyName: assemblyModalShow.assemblyName,
                            locationId: assemblyModalShow.locationId,
                          })
                        }
                      />
                    </div>
                  </Tab>
                </Tabs>

                {/* Hidden field to store location_id */}
                <input
                  type="hidden"
                  {...registerAssembly("location_id")}
                  value={assemblyModalShow.locationId} // Use locationId from modal state
                />

                {/* Hidden field to store course_id */}
                <input
                  type="hidden"
                  {...registerAssembly("course_id")}
                  value={assemblyModalShow.courseId} // Use locationId from modal state
                />
              </div>
            </div>
          </form>
        }
      />

      {/* Fixture Modal */}
      <FixtureModal
        show={fixtureModalShow.show}
        onHide={closeFixtureModal}
        fixtureData={fixtureData}
        zoneId={fixtureModalShow.zoneId}
        mode={fixtureModalShow.mode}
        ZoneAssembly={fixtureModalShow.ZoneAssembly}
      />

      {/* Quest Modal */}
      <QuestModal
        show={questModalShow.show}
        onHide={closeQuestModal}
        courseIncidentTypesData={courseIncidentTypesData}
        courseId={questModalShow.courseId}
        mode={questModalShow.mode}
      />

      {/* Copy Quest Modal */}
      <CustomModal
        show={copyQuestModalShow.show}
        onHide={() => setCopyQuestModalShow({ show: false, courseId: "", incidentTypeId: "", incidentTypeName: "" })}
        heading={`Copy Quest: ${copyQuestModalShow.incidentTypeName}`}
        size="md"
        body={
          <CopyQuestForm
            onSubmit={handleCopyQuest}
            onCancel={() => setCopyQuestModalShow({ show: false, courseId: "", incidentTypeId: "", incidentTypeName: "" })}
            defaultName={`${copyQuestModalShow.incidentTypeName} - Copy`}
          />
        }
      />

      {/* Clone Course Group (Quest Area) Modal */}
      <CustomModal
        show={cloneCourseGroupModalShow.show}
        onHide={() => setCloneCourseGroupModalShow({ show: false, courseGroupId: "", courseGroupName: "", defaultStartingMarker: "" })}
        heading={`Clone Quest Area: ${cloneCourseGroupModalShow.courseGroupName}`}
        size="md"
        body={
          <CloneCourseGroupForm
            onSubmit={handleCloneCourseGroup}
            onCancel={() => setCloneCourseGroupModalShow({ show: false, courseGroupId: "", courseGroupName: "", defaultStartingMarker: "" })}
            defaultStartingMarker={cloneCourseGroupModalShow.defaultStartingMarker}
          />
        }
      />

      {/* delete modal */}
      <CustomModal
        show={deleteModal.show}
        onHide={() => setDeleteModal({ show: false })}
        // heading="Delete Campus"
        size="md"
        body={
          <div className="deleteModal">
            <p className="text-center mb-5">
              Are you sure, you want to remove this {deleteModal.name}?
            </p>
            <div className="d-flex justify-content-between align-items-center custom_bottom_padding">
              <button
                type="button"
                className="submit_btn"
                onClick={() =>
                  deleteModal.type === "course"
                    ? removeCourse(deleteModal.id)
                    : deleteModal.type === "quest"
                      ? removeQuest(deleteModal.id, deleteModal.incidentTypeId)
                      : removeCourseFixture(deleteModal.id)
                }
              >
                Yes
              </button>
              <button
                type="button"
                className="cancleBtn"
                onClick={() => setDeleteModal({ show: false })}
              >
                No
              </button>
            </div>
          </div>
        }
      />

      {/* delete Assembly modal */}
      <CustomModal
        show={deleteAssemblyModal.show}
        onHide={() => setDeleteAssemblyModal({ show: false })}
        // heading="Delete Campus"
        size="md"
        body={
          <div className="deleteModal">
            <p className="text-center mb-5">
              Are you sure, you want to delete this assembly{" "}
              {deleteAssemblyModal.assemblyName}?
            </p>
            <div className="d-flex justify-content-between align-items-center custom_bottom_padding">
              <button
                type="button"
                className="submit_btn"
                onClick={() =>
                  removeAssemblyPoint(
                    deleteAssemblyModal.courseId,
                    deleteAssemblyModal.assemblyId
                  )
                }
              >
                Yes
              </button>
              <button
                type="button"
                className="cancleBtn"
                onClick={() => setDeleteModal({ show: false })}
              >
                No
              </button>
            </div>
          </div>
        }
      />

      {/* Print Popup */}
      <CustomModal
        show={printModalShow.show}
        onHide={() =>
          setPrintModalShow({
            show: false,
            html: "",
            cclink: "",
            ccqrcodeurl: "",
            testlink: "",
            testqrcodeurl: "",
            id: "",
            name: "",
            testKey: null,
            incidentTypeId: "",
          })
        }
        // heading="Print"
        heading={
          <div className="d-flex justify-content-between align-items-center">
            <button
              type="button"
              className="qr-link mt-4"
              title="Print"
              onClick={() =>
                handlePrintClick(printModalShow.id, printModalShow.name, printModalShow.testKey, printModalShow.incidentTypeId)
              }
            >
              Print
            </button>
            <p className="textStyle">
              {printModalShow.testKey ? "If you have not already, 'Print' the quest & start fresh with scanning new Take Test QR below." : "If you have not already, 'Print' the quest & start fresh with scanning new Quest Creation QR below."}
            </p>
          </div>
        }
        size="md"
        className="custom-modal"
        body={
          <>
            <div className="text-center">
              <h2 className="mb-4">
                <b>
                  {printModalShow.testKey ? "Scan to Take Test" : "Scan to complete Quest Creation"}
                </b>
              </h2>
              <p className="mb-4">
                {printModalShow.testKey ? "" : "The remainder of the quest installation will occur on a mobile device. Please scan this code to be taken directly to the quest creator and follow the instructions."}
              </p>
              <div>
                <img
                  src={printModalShow?.ccqrcodeurl}
                  alt=""
                  className="scannerImg"
                />
                <h2 className="mt-4">
                  <b>
                    Copy Quest Launch Link:
                  </b>
                </h2>
                {/* Input Box */}
                <input
                  type="text"
                  className="form-control mt-3"
                  value={printModalShow?.cclink || ""}
                  readOnly
                  // onClick={(e) => {
                  //   navigator.clipboard.writeText(e.target.value);
                  //   toast.success('Quest Link Copied.');
                  // }}
                  onClick={(e) => {
                    e.target.select();  // ⭐ Force select (important)

                    navigator.clipboard
                      .writeText(e.target.value)
                      .then(() => {
                        toast.success("Quest Link Copied.");
                      })
                      .catch(() => {
                        toast.error("Copy failed!");
                      });
                  }}
                />
              </div>

              {/* Canvas Download */}
              {/* <div style={{ border: "1px solid black", textAlign: "center", marginTop: "20px" }}>
                <canvas ref={houseCanvasRef} width={300} height={300} style={{ background: "white" }} />
                <canvas ref={busCanvasRef} width={300} height={300} style={{ background: "white" }} />
              </div>
              <button onClick={downloadZip} style={{ marginTop: "10px", padding: "10px" }}>
                Download Zip
              </button> */}


              {/* Show the generated image */}
              {/* {printModalShow.imageUrl && (
                <div className="mt-4">
                  <h4>Generated Preview</h4>
                  <img
                    src={printModalShow.imageUrl}
                    alt="Generated Course Preview"
                    style={{
                      width: "100%",
                      maxHeight: "400px",
                      objectFit: "contain",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              )} */}

              {/* Optional: Download Button */}
              {/* {printModalShow.imageUrl && (
                <a
                  href={printModalShow.imageUrl}
                  download={`${printModalShow.name}.png`}
                  className="btn btn-primary mt-3"
                >
                  Download Image
                </a>
              )} */}

              {/* <div className="mt-4">
                <p>
                  <strong>Current testKey value:</strong>{" "}
                  {JSON.stringify(printModalShow.testKey)}
                </p>
              </div> */}

            </div>
          </>
        }
      />

      {/* Confirmation Modal */}
      <CustomModal
        show={confirmModalShow.show}
        onHide={() => setConfirmModalShow(false)}
        size="md"
        body={
          <div className="deleteModal">
            <p className="text-center mb-5">
              Are you sure ?<br></br>
              Re-printing this quest will create a new launch link. The previous link associated with this quest will no longer be valid.
            </p>
            <div className="d-flex justify-content-between align-items-center custom_bottom_padding">
              <button type="button" className="submit_btn" onClick={handleConfirmPrint}>
                Yes
              </button>
              <button type="button" className="cancleBtn" onClick={() => setConfirmModalShow(false)}>
                No
              </button>
            </div>
          </div>
        }
      />

      {/* Test Popup */}
      <CustomModal
        show={testQRShow.show}
        onHide={() =>
          setTestQRShow({
            show: false,
            uuid: "",
            qrcodeurl: "",
          })
        }
        // heading="Print"
        size="md"
        className=""
        body={
          <>
            <div className="text-center">
              <h2 className="mb-5">
                <b>Scan to Take Test</b>
              </h2>
              {testQRShow?.qrcodeurl ? (
                <img
                  src={testQRShow.qrcodeurl}
                  className="scannerImg"
                  alt="Quest QR Code"
                />
              ) : (
                <p>QR Code not available</p>
              )}
            </div>
          </>
        }
      />

      {/* download modal - per quest */}
      <CustomModal
        show={downloadModal.show}
        onHide={() => setDownloadModal({ show: false, courseId: "", incidentTypeId: "", questName: "", gps: false, published: "" })}
        heading={`Download SCORM${downloadModal.questName ? `: ${downloadModal.questName}` : ''}`}
        size="md"
        body={
          <div className="deleteModal">
            <div className="d-flex justify-content-center align-items-center custom_bottom_padding">
              <button
                type="button"
                className="cancleBtn mr-2"
                onClick={() => downloadScorm(downloadModal.courseId, downloadModal.incidentTypeId, downloadModal.gps ? 1 : 0, downloadModal.questName, true)}
              >
                Test SCORM
              </button>
              {downloadModal.published === 1 && (
                <button
                  type="button"
                  className="cancleBtn"
                  onClick={() => downloadScorm(downloadModal.courseId, downloadModal.incidentTypeId, downloadModal.gps ? 1 : 0, downloadModal.questName, false)}
                >
                  Live SCORM
                </button>
              )}
            </div>
          </div>
        }
      />

    </>
  );
}

export default Courses;